import React from "react";

// ✅ Red-safe emoji set: yellow, white, light-blue tones
const CHAR_EMOJI = {
  // Letters
  a: "🍋", // lemon
  b: "🧊", // ice cube
  c: "🧀", // cheese
  d: "🥚", // egg
  e: "⭐", // star
  f: "🧻", // paper roll
  g: "🌼", // blossom
  h: "🧼", // soap
  i: "🕯️", // candle
  j: "🪙", // coin
  k: "🔑", // key
  l: "📒", // notebook (yellow)
  m: "🍌", // banana
  n: "🔔", // bell
  o: "🟨", // yellow square
  p: "🧽", // sponge
  q: "👑", // crown
  r: "🧾", // receipt
  s: "☀️", // sun
  t: "🌕", // full moon
  u: "☁️", // cloud
  v: "🕊️", // dove
  w: "❄️", // snowflake
  x: "✨", // sparkles
  y: "🟡", // yellow circle
  z: "⚪️", // white circle

  // Digits
  "0": "⭕",  // hollow circle
  "1": "☝️", // pointing finger (clear white/yellow)
  "2": "🥈", // silver medal
  "3": "🥉", // bronze medal (still bright)
  "4": "🍀", // four-leaf clover
  "5": "✋", // raised hand
  "6": "🎱", // billiards ball (white/black – still clear)
  "7": "🌈", // rainbow
  "8": "🎱", // reuse billiards ball for 8
  "9": "🔔", // bell
};

export default function LetterEmoji({ text, size = 21, className = "" }) {
  const fallback = "✨"; // safe fallback
  if (!text) return <span style={{ fontSize: size }}>{fallback}</span>;

  // take last non-space character
  const ch = text.toString().trim().slice(-1).toLowerCase();
  const emoji = CHAR_EMOJI[ch] || fallback;

  return (
    <span
      className={className}
      style={{ fontSize: size, lineHeight: 1 }}
      role="img"
      aria-label={`emoji for ${ch || "unknown"}`}
    >
      {emoji}
    </span>
  );
}